import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "Nome",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "Immettere il nome."
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "Cognome",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "Immettere il cognome."
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "Numero di telefono  ",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "Immettere un numero di telefono valido.",
    "Immettere un numero di telefono valido."
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "Numero di telefono secondario",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "Immettere un numero di telefono valido."
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "Indirizzo di consegna Campo 1",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "Immettere l'indirizzo."
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "Indirizzo di consegna Campo 2",
  "size": 100,
  "model": "address2"
},
{
  "id": "city",
  "type": "input",
  "label": "Città",
  "size": 50,
  "model": "city"
},
{
  "id": "state",
  "type": "input",
  "label": "Stato / Provincia",
  "size": 50,
  "model": "state"
},
{
  "id": "postal-code",
  "type": "input",
  "label": "CAP / Codice di avviamento postale",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "Immettere un codice di avviamento postale valido."
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "Paese / Regione",
  "size": 50,
  "model": "countryName"
}
]